import { observer } from 'mobx-react-lite'
import { Filter } from 'page/catalog/DemoCatalogFilters/Filter'
import { Button } from 'component/Button'
import { Space } from 'component/Space'
import { Vertical } from 'component/Vertical'
import { i18n } from 'i18n'
import { comboCartStore } from 'page/catalog/store/ComboCartStore'
import { useDemo } from 'page/catalog/store/CatalogContext'
import css from './ComboCartFiltersScreen.module.scss'

interface ComboCartFiltersScreenProps {
  currentStep: 'top' | 'bottom'
  onApply: () => void
}

export const ComboCartFiltersScreen = observer(
  ({ currentStep, onApply }: ComboCartFiltersScreenProps) => {
    const demo = useDemo()
    const filters =
      currentStep === 'top'
        ? comboCartStore.topFilters
        : comboCartStore.bottomFilters
    const { brands, colors } = filters

    const handleFilterOpen = (openingFilter: any) => {
      if (openingFilter !== brands) brands.open = false
      if (openingFilter !== colors) colors.open = false
    }

    const colorOptions = demo.options.colors || []
    const brandOptions = demo.options.brands || []

    return (
      <Vertical className={css.container}>
        <div className={css.filtersContainer}>
          {colorOptions.length > 0 && (
            <Filter
              filter={colors}
              options={colorOptions}
              inline={true}
              onOpen={() => handleFilterOpen(colors)}
            />
          )}

          {brandOptions.length > 0 && (
            <Filter
              filter={brands}
              options={brandOptions}
              inline={true}
              onOpen={() => handleFilterOpen(brands)}
            />
          )}
        </div>

        <Space className={css.footer}>
          <Button wide xl primary action={onApply}>
            {i18n('combo.Apply')}
          </Button>
        </Space>
      </Vertical>
    )
  }
)
